var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card-content-table" }, [
    _c("table", [
      _c("thead", [
        _c(
          "tr",
          { staticClass: "border-bottom" },
          _vm._l(_vm.columns, function(column) {
            return _c("th", { key: column }, [
              _vm._v("\n            " + _vm._s(column) + "\n          ")
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.data, function(item, i) {
          return _c("tr", { key: i }, [
            _c("td", [_vm._v(_vm._s(item.orderDate))]),
            _vm._v(" "),
            _c("td", [
              _vm._v(_vm._s(_vm.formatNumber(item.value) + " " + item.unit))
            ]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.formatRate(item.rate)))])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-079e802f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-079e802f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/home/components/TableSalesGrowth.vue
// module id = null
// module chunks = 